import moment from 'moment'
import {
  prettyDateFormat,
} from '@/components/mixins/MomentUtil'

export const METADATA_FIELD_TYPES = {
  string: {
    value: 'string',
    text: 'Text',
  },
  number: {
    value: 'number',
    text: 'Number',
  },
  datetime: {
    value: 'datetime',
    text: 'Date',
  },
}

export function getMetadataValue(metadata) {
  if (!metadata || !metadata.FieldValue) return

  if (metadata.FieldType == METADATA_FIELD_TYPES.datetime.value) {
    return moment(metadata.FieldValue).format(prettyDateFormat)
  }

  return metadata.FieldValue
}